import download from 'downloadjs';
import { icons } from '../../assets/assets';
import GameMaterialItem from './GameMaterialItem';

export default class AudioGameMaterial extends GameMaterialItem {
  constructor(props) {
    super(props);
    this.state.loading = false;
    this.state.icons = [];
    if (props.gameId === 4 && navigator.userAgent.match(/(iPhone|iPod|iPad)/i)) {
      this.state.icons.push({
        src: icons.download,
        alt: 'icon',
        style: { margin: '20px 20px 20px 20px' },
        onClick: this.handleDownload,
      });
    }
    this.state.icons.push(icons.play2);
    this.handleClick = () => {
      window.open(`/portal/audio/${props.item.AudioId || props.item.MaterialId || props.item.FileId}?windowTitle=${encodeURIComponent(props.item.windowTitle)}&faviconUrl=${encodeURIComponent(props.item.faviconUrl)}`, '_blank');
    }
  }

  handleDownload = async (ev) => {
    ev.preventDefault();
    ev.stopPropagation();
    if (this.state.loading) return false;
    this.setState({ loading: true });
    const { filename, url } = this.props.item.Material;
    await fetch(url, { method: 'GET' })
      .then(resp => resp.blob())
      .then(resp => download(resp, filename))
      .catch(console.warn);
    this.setState({ loading: false });
    return false;
  };
}

// import { Howl } from 'howler';
//
// import { icons } from '../../assets/assets';
// import GameMaterialItem from './GameMaterialItem';

// export default class AudioGameMaterial extends GameMaterialItem {
//   constructor(props) {
//     super(props);
//     this.playIcon = {
//       src: icons.play2,
//       alt: 'play-icon',
//       onClick: () => {
//         if (this.howl instanceof Howl === true) {
//           if (!this.state.playing) {
//             this.howl.play();
//           }
//         }
//       },
//     };
//     this.pauzeIcon = {
//       src: icons.pauze,
//       alt: 'pause-icon',
//       onClick: () => {
//         if (this.howl instanceof Howl === true) {
//           if (this.state.playing) {
//             this.howl.pause();
//           }
//         }
//       },
//     };
//     this.downloadIcon = {
//       src: icons.download,
//       alt: 'download-icon',
//       onClick: (ev) => {
//         super.download(ev);
//       },
//     };
//     this.state.playing = false;
//     this.state.paused = false;
//     this.state.stopped = false;
//     this.state.loaded = false;
//     this.state.icons = [
//       this.downloadIcon,
//       {
//         ...this.playIcon,
//         style: {
//           pointerEvents: 'none',
//           opacity: '0.5',
//         },
//         onClick: () => {},
//       }
//     ];
//     this.howl = new Howl({
//       html5: true,
//       src: [props.item.Material.url],
//       onload: this.handleOnLoad,
//       onpause: this.handlePause,
//       onplay: this.handlePlay,
//       onstop: this.handleStop,
//       onloaderror: this.handleLoadError,
//     });
//     this.handleClick = () => {}
//     this.componentWillUnmount = () => {
//       if (this.howl instanceof Howl === true) {
//         this.howl.unload();
//         delete this.howl;
//       }
//       super.componentWillUnmount();
//     }
//   }
//   handlePause = () => {
//     this.setState({
//       playing: false,
//       paused: true,
//       stopped: false,
//       icons: [this.downloadIcon, this.playIcon],
//     });
//   };
//   handlePlay = () => {
//     this.setState({
//       playing: true,
//       paused: false,
//       stopped: false,
//       icons: [this.downloadIcon, this.pauzeIcon],
//     });
//   };
//   handleStop = () => {
//     this.setState({
//       playing: false,
//       paused: false,
//       stopped: true,
//       icons: [this.downloadIcon, this.playIcon],
//     });
//   };
//   handleOnLoad = () => {
//     this.setState({ loaded: true, icons: [this.downloadIcon, this.playIcon] });
//   };
//   handleLoadError = (id, err) => {
//     console.error(err);
//   }
// }



// WEBPACK FOOTER //
// ./src/components/elements/AudioGameMaterial.js